import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type AdminStatAccent = 'primary' | 'success' | 'purple' | 'warning' | 'neutral';

@Component({
  selector: 'app-admin-stat-card',
  standalone: true,
  imports: [CommonModule, DecimalPipe, TranslatePipe],
  templateUrl: './admin-stat-card.component.html',
  styleUrl: './admin-stat-card.component.scss',
})
export class AdminStatCardComponent {
  labelKey = input.required<string>();
  value = input<string | number | null>(null);
  hintKey = input<string | null>(null);
  accent = input<AdminStatAccent>('neutral');
  loading = input(false);
}
